import React from 'react';
import { useParams } from 'react-router-dom';
import ShipperFscSettings from 'components/modules/user/shipper/FscSettings';
import SessionStore from 'stores/SessionStore';
import RatesSettingsLayout from '../RatesSettingsLayout';

export default function FscSettings() {
  const { id } = useParams();

  if (!SessionStore.isAbleToEditShorthaulFSC()) {
    return null;
  }

  return (
    <RatesSettingsLayout activeTab="shorthaulFsc">
      <ShipperFscSettings shipperId={id} />
    </RatesSettingsLayout>
  );
}
